var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterFunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8027 3.29245C17.9292 3.59751 17.8771 3.85792 17.6464 4.0737L12.1442 9.57593V17.8572C12.1442 18.1697 11.9991 18.3892 11.7089 18.5157C11.6122 18.5529 11.5192 18.5715 11.4299 18.5715C11.229 18.5715 11.0616 18.5008 10.9277 18.3594L8.07054 15.5023C7.92918 15.3609 7.85849 15.1935 7.85849 15V9.57593L2.35626 4.0737C2.1256 3.85792 2.07352 3.59751 2.20001 3.29245C2.3265 3.00227 2.54599 2.85718 2.85849 2.85718H17.1442C17.4567 2.85718 17.6762 3.00227 17.8027 3.29245Z",
    fill: "#344051"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterFunnel);
export default __webpack_public_path__ + "static/media/FilterFunnel.248d2b33a6a614ed82327afedc480ea4.svg";
export { ForwardRef as ReactComponent };